var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      class: ["box-card", _vm.optStatusEdit ? "" : ""],
      staticStyle: { height: "30%" }
    },
    [
      _c(
        "div",
        {
          staticStyle: { padding: "2px 0" },
          attrs: { slot: "header" },
          slot: "header"
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("SystemMaintenance.APIOutputAdditionalInformation"))
            )
          ])
        ]
      ),
      _c("cargo-ag-grid", {
        attrs: {
          "grid-params": _vm.gridParams,
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          }
        }
      }),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.optStatusEdit },
              on: { click: _vm.addHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", disabled: !_vm.optStatusEdit },
              on: { click: _vm.removeHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }